import { render, staticRenderFns } from "./SupportTicketAvatar.vue?vue&type=template&id=73eb5b29&"
import script from "./SupportTicketAvatar.vue?vue&type=script&lang=js&"
export * from "./SupportTicketAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports